"use strict";
/**
 * Common utilities and helpers for Excel sheet generation
 *
 * This module provides shared functions used across all sheet generators.
 * Note: ApplicationInsights is now injected via SheetsGeneratorConfig.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatDate = exports.matrixHeadersDefaultFontSize = exports.matrixHeadersDefaultRowHeight = exports.firstSevenRowsFontSize = exports.firstSevenRowsLastRowHeight = exports.firstSevenRowsHeight = void 0;
exports.extractWasteCode = extractWasteCode;
exports.extractWasteDescription = extractWasteDescription;
exports.isDangerousWaste = isDangerousWaste;
exports.isValidWasteCode = isValidWasteCode;
exports.insertCopyrightRow = insertCopyrightRow;
exports.insertTrialNoticeRow = insertTrialNoticeRow;
exports.limitTrialData = limitTrialData;
exports.convertToExcelDate = convertToExcelDate;
exports.isValidKpoCardNumber = isValidKpoCardNumber;
exports.extractYearFromKpoCardNumber = extractYearFromKpoCardNumber;
exports.extractPointIdFromKpoCardNumber = extractPointIdFromKpoCardNumber;
exports.isValidKeoCardNumber = isValidKeoCardNumber;
exports.extractYearFromKeoCardNumber = extractYearFromKeoCardNumber;
exports.extractPointIdFromKeoCardNumber = extractPointIdFromKeoCardNumber;
exports.firstSevenRowsHeight = 20;
exports.firstSevenRowsLastRowHeight = 10;
exports.firstSevenRowsFontSize = 10;
exports.matrixHeadersDefaultRowHeight = 40;
exports.matrixHeadersDefaultFontSize = 12;
/**
 * Funkcja wyciąga kod odpadu z ciągu znaków.
 * @param {string} input - ciąg znaków zawierający kod odpadu
 * @returns {string | null} - zwraca kod odpadu lub null, jeśli nie znaleziono
 */
function extractWasteCode(input) {
    var match = input.match(/^[\d\s\*]+/);
    return match ? match[0].trim() : null;
}
/**
 * Funkcja wyciąga opis odpadu z ciągu znaków.
 * @param {string} input - ciąg znaków zawierający kod i opis odpadu
 * @returns {string | null} - zwraca opis odpadu lub null, jeśli nie znaleziono
 */
function extractWasteDescription(input) {
    var match = input.match(/^[\d\s\*]+/);
    if (match) {
        // usuń kod odpadu z początku i przytnij spacje
        var description = input.substring(match[0].length).trim();
        // usuń "- " z początku jeśli istnieje
        if (description.startsWith("- ")) {
            description = description.substring(2).trim();
        }
        return description || null;
    }
    return null;
}
/**
 * Funkcja sprawdza czy w kodzie jest znak * (co oznacza, że jest to kod odpadu niebezpiecznego) i zwraca TRUE dla niebezpiecznego, FALSE dla innego.
 * @param {string} wasteCode - kod odpadu
 * @returns {boolean} - TRUE jeśli odpady są niebezpieczne, FALSE jeśli odpady są inne
 */
function isDangerousWaste(wasteCode) {
    return wasteCode.includes("*");
}
/**
 * Formatowanie daty do formatu "dd.mm.yyyy hh:mm"
 * @param dateString
 * @returns
 */
var formatDate = function (dateString) {
    if (!dateString)
        return "";
    var date = new Date(dateString);
    return date.toLocaleDateString("pl-PL") + " " + date.toLocaleTimeString("pl-PL", { hour: '2-digit', minute: '2-digit' });
};
exports.formatDate = formatDate;
/**
 * Funkcja sprawdza czy kod odpadu jest zgodny z formatem
 * @param wasteCode - kod odpadu
 * @returns TRUE jeśli kod jest zgodny, FALSE w przeciwnym przypadku
 */
function isValidWasteCode(wasteCode) {
    // Akceptuje formaty: "XX XX XX" i "XX XX XX*" (gwiazdka bez spacji)
    var regex = /^\d{2} \d{2} \d{2}\*?$/;
    return regex.test(wasteCode);
}
/**
 * Uniwersalna metoda wstawiająca copyright z linkiem do CARBOmath w określonym zakresie komórek
 * @param sheet - obiekt arkusza Excel.Worksheet w otwartym kontekście
 * @param columnRange - zakres kolumn z numerem wiersza (np. "A14:H14")
 * @param includeLink - czy włączyć hyperlink do www.carbomath.com (domyślnie false)
 * @param config - Configuration with ApplicationInsights instance
 */
function insertCopyrightRow(sheet_1, columnRange_1) {
    return __awaiter(this, arguments, void 0, function (sheet, columnRange, includeLink, config) {
        var currentYear, range, firstColumn, copyrightCell, lastColumn, dateCell, now, formattedDate;
        if (includeLink === void 0) { includeLink = false; }
        return __generator(this, function (_a) {
            try {
                currentYear = new Date().getFullYear();
                range = sheet.getRange(columnRange);
                range.format.fill.color = "#688BBB";
                range.format.font.color = "#FFFFFF";
                range.format.rowHeight = 15;
                range.format.horizontalAlignment = "Left";
                range.format.verticalAlignment = "Center";
                range.format.font.size = 10;
                range.format.font.underline = "None";
                firstColumn = columnRange.split(":")[0];
                copyrightCell = sheet.getRange(firstColumn);
                if (includeLink) {
                    // Utwórz hyperlink bezpośrednio dla całej komórki
                    copyrightCell.values = [["=HYPERLINK(\"https://www.carbomath.com\", \"Copyright \u00A9 ".concat(currentYear, " CARBOmath\")")]];
                    copyrightCell.format.font.underline = "Single";
                }
                else {
                    // Zwykły tekst bez linku
                    copyrightCell.values = [["Copyright \u00A9 ".concat(currentYear, " CARBOmath")]];
                }
                lastColumn = columnRange.split(":")[1];
                dateCell = sheet.getRange(lastColumn);
                now = new Date();
                formattedDate = now.toLocaleDateString("pl-PL") + " " + now.toLocaleTimeString("pl-PL", { hour: '2-digit', minute: '2-digit' });
                dateCell.values = [["Utworzono: ".concat(formattedDate)]];
                dateCell.format.horizontalAlignment = "Right";
            }
            catch (error) {
                // Track exception if config provided
                if (config === null || config === void 0 ? void 0 : config.appInsights) {
                    config.appInsights.trackException({ exception: error });
                }
            }
            return [2 /*return*/];
        });
    });
}
/**
 * Uniwersalna metoda wstawiająca informację o wersji trial w określonym zakresie komórek
 * @param sheet - obiekt arkusza Excel.Worksheet w otwartym kontekście
 * @param columnRange - zakres kolumn z numerem wiersza (np. "A13:H13")
 * @param isTrial - czy użytkownik korzysta z wersji trial
 * @param config - Configuration with ApplicationInsights instance
 */
function insertTrialNoticeRow(sheet, columnRange, isTrial, config) {
    return __awaiter(this, void 0, void 0, function () {
        var range, firstColumn, trialCell;
        return __generator(this, function (_a) {
            try {
                // Wyświetl tylko jeśli użytkownik ma trial
                if (!isTrial) {
                    return [2 /*return*/];
                }
                range = sheet.getRange(columnRange);
                range.format.fill.color = "#FF0000";
                range.format.font.color = "#FFFFFF";
                range.format.rowHeight = 15;
                range.format.horizontalAlignment = "Left";
                range.format.verticalAlignment = "Center";
                range.format.font.size = 10;
                range.format.font.bold = true;
                firstColumn = columnRange.split(":")[0];
                trialCell = sheet.getRange(firstColumn);
                trialCell.values = [["Uwaga: korzystasz z wersji pr\u00F3bnej. Ograniczenie do maksymalnie 5 rekord\u00F3w danych z systemu BDO."]];
            }
            catch (error) {
                // Track exception if config provided
                if (config === null || config === void 0 ? void 0 : config.appInsights) {
                    config.appInsights.trackException({ exception: error });
                }
            }
            return [2 /*return*/];
        });
    });
}
/**
 * Ogranicza dane do maksymalnie 5 rekordów w wersji trial
 * @param data - array danych do ograniczenia
 * @param isTrial - czy użytkownik korzysta z wersji trial
 * @returns ograniczona lista danych
 */
function limitTrialData(data, isTrial) {
    if (!isTrial) {
        return data;
    }
    return data.slice(0, 5);
}
/**
 * Konwertuje string daty ISO 8601 na liczbę seryjną daty Excel
 * @param dateString - String daty w formacie ISO 8601 (np. "2025-07-06T06:32:59.466Z")
 * @returns Liczba seryjna daty Excel
 */
function convertToExcelDate(dateString) {
    var date = new Date(dateString);
    // Excel używa liczby dni od 1 stycznia 1900 (z poprawką na błąd leap year)
    // JavaScript Date używa milisekund od 1 stycznia 1970
    var excelEpoch = new Date(1900, 0, 1);
    var msPerDay = 24 * 60 * 60 * 1000;
    // Obliczanie różnicy w dniach + 1 (Excel liczy od 1, nie od 0)
    // +1 dodatkowy dzień z powodu błędu w Excel (1900 nie był rokiem przestępnym)
    return Math.floor((date.getTime() - excelEpoch.getTime()) / msPerDay) + 1 + 1;
}
/**
 * Metoda sprawdza poprawność numeru karty KPO. Każda karta ma zdefiniowany format XXXXX/YYYY/KPO/XXXX/XXXXXXXXX, gdzie X to cyfra a YYYY to rok zapisany cyframi np.: '00001/2026/KPO/0001/000097854'
 * @param kpoCardNumber - numer karty KPO do sprawdzenia
 * @returns TRUE jeśli numer karty jest poprawny, FALSE w przeciwnym przypadku
 */
function isValidKpoCardNumber(kpoCardNumber) {
    var regex = /^\d{5}\/\d{4}\/KPO\/\d{4}\/\d{9}$/;
    return regex.test(kpoCardNumber);
}
/**
 * Metoda z poprawnie sformatowanego numeru karty KPO wyciaga 4 cyfrowy rok jako number, który jest zapisany w numerze karty.
 * @param kpoCardNumber - numer karty KPO
 * @returns rok jako liczba całkowita lub null jeśli nie udało się wyciągnąć roku
 */
function extractYearFromKpoCardNumber(kpoCardNumber) {
    var regex = /^\d{5}\/(\d{4})\/KPO\/\d{4}\/\d{9}$/;
    var match = kpoCardNumber.match(regex);
    if (match && match[1]) {
        return parseInt(match[1], 10);
    }
    return null;
}
/**
 * Metoda z poprawnie sformatowanego numeru karty KPO wyciąga identydikator punktu jako string, stanowi go ostnai człon numeru karty KPO po słowie kluczowym KPO, czyli z numeru o formacie XXXXX/YYYY/KPO/XXXX/XXXXXXXXX identyfikator to XXXX/XXXXXXXXX
 * @param kpoCardNumber - numer karty KPO
 * @returns identyfikator punktu jako string lub null jeśli nie udało się wyciągnąć identyfikatora
 */
function extractPointIdFromKpoCardNumber(kpoCardNumber) {
    var regex = /^\d{5}\/\d{4}\/KPO\/(.{13})$/;
    var match = kpoCardNumber.match(regex);
    if (match && match[3] && match[4]) {
        return match[3] + "/" + match[4];
    }
    return null;
}
/**
 * Metoda sprawdza poprawność numeru KEO. Każdy KEO ma zdefiniowany format XXXXX/YYYY/KEO/XXXX/XXXXXXXXX, gdzie X to cyfra a YYYY to rok zapisany cyframi np.: '00001/2026/KEO/0001/000097854'
 * @param keoCardNumber - numer KEO do sprawdzenia
 * @returns TRUE jeśli numer KEO jest poprawny, FALSE w przeciwnym przypadku
 */
function isValidKeoCardNumber(keoCardNumber) {
    var regex = /^\d{5}\/\d{4}\/KEO\/\d{4}\/\d{9}$/;
    return regex.test(keoCardNumber);
}
/**
 * Metoda z poprawnie sformatowanego numeru KEO wyciaga 4 cyfrowy rok jako number, który jest zapisany w numerze KEO.
 * @param keoCardNumber - numer KEO
 * @returns rok jako liczba całkowita lub null jeśli nie udało się wyciągnąć roku
 */
function extractYearFromKeoCardNumber(keoCardNumber) {
    var regex = /^\d{5}\/(\d{4})\/KEO\/\d{4}\/\d{9}$/;
    var match = keoCardNumber.match(regex);
    if (match && match[1]) {
        return parseInt(match[1], 10);
    }
    return null;
}
/**
 * Metoda z poprawnie sformatowanego numeru karty KEO wyciąga identydikator punktu jako string, stanowi go ostnai człon numeru karty KEO po słowie kluczowym KEO, czyli z numeru o formacie XXXXX/YYYY/KEO/XXXX/XXXXXXXXX identyfikator to XXXX/XXXXXXXXX
 * @param keoCardNumber - numer karty KEO
 * @returns identyfikator punktu jako string lub null jeśli nie udało się wyciągnąć identyfikatora
 */
function extractPointIdFromKeoCardNumber(keoCardNumber) {
    var regex = /^\d{5}\/\d{4}\/KEO\/(.{13})$/;
    var match = keoCardNumber.match(regex);
    if (match && match[3] && match[4]) {
        return match[3] + "/" + match[4];
    }
    return null;
}
//# sourceMappingURL=common.js.map